import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import { dateString } from 'utils/common'

interface IProps {
  edi?: any
  level: number
}

const EDI = ({ edi, level }: IProps) => (
  <Grid container direction="column">
    {edi && (
      <Grid container item direction="column">
        <Grid item>
          <Box my={{ xs: 1 }}>
            <Typography variant="h4" color="secondary">
              Placed {edi.datetime != undefined ? dateString(edi.datetime, true) : 'N/A'}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Box my={{ xs: 1 }}>
            <Typography variant="h4" color="secondary">
              @Level  {edi.level != undefined ? edi.level.toFixed(0) + '%' : 'N/A'}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    )}
    {!edi && (
      <Grid container item direction="column">
        <Grid item>
          <Box my={{ xs: 1 }}>
            <Typography variant="h4" color="secondary">
              No Order Submitted
            </Typography>
          </Box>
        </Grid>
        {level > 80 && (
          <Grid item>
            <Box my={{ xs: 1 }}>
              <Typography variant="h4" color="secondary">
                80% Minimum Order Level
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    )}
  </Grid>
)

export default React.memo(EDI)
